gsap.registerPlugin(ScrollTrigger, SplitText);
gsap.config({
    nullTargetWarn: false,
    trialWarn: false
});


// ** ccos Title Animation ** \\
function ccos_title_animation() {

	ScrollTrigger.matchMedia({
		"(min-width: 991px)": function() {

		var ccos_var = jQuery('.ccos-heading, .ccos-heading-subheading');
		if (!ccos_var.length) {
			return;
		}
		const quotes = document.querySelectorAll(".ccos-heading-subheading .ccos-title, .ccos-heading .ccos-title");

			quotes.forEach(quote => {

				//Reset if needed
				if (quote.animation) {
					quote.animation.progress(1).kill();
					quote.split.revert();
				}

				var getclass = quote.closest('.ccos-heading-subheading, .ccos-heading').className;
				var animation = getclass.split('animation-');
				if (animation[1] == "style4") return

				quote.split = new SplitText(quote, {
					type: "lines,words,chars",
					linesClass: "split-line"
				});
				gsap.set(quote, { perspective: 400 });

				if (animation[1] == "style1") {
					gsap.set(quote.split.chars, {
						opacity: 0,
						y: "90%",
						rotateX: "-40deg"
					});
				}
				if (animation[1] == "style2") {
					gsap.set(quote.split.chars, {
						opacity: 0,
						x: "50"
					});
				}
				if (animation[1] == "style3") {
					gsap.set(quote.split.chars, {
						opacity: 0,
					});
				}
				quote.animation = gsap.to(quote.split.chars, {
					scrollTrigger: {
						trigger: quote,
						start: "top 90%",
					},
					x: "0",
					y: "0",
					rotateX: "0",
					opacity: 1,
					duration: 1,
					ease: Back.easeOut,
					stagger: .02
				});
			});
		},
	});
}


function ccos_staticbox_hover() {
	var ccos_var = jQuery('.ccos-element-static-box-style-1, .ccos-element-static-box-style-2, .ccos-element-service-style-4');
	if (!ccos_var.length) {
		return;
	}
	ccos_var.each(function() {
		var ccos_Class = '.ccos-element-posts-wrapper > .ccos-ele-static-box, .swiper-static-slide-nav li, .ccos-hover-inner li, .ccos-service-style-4';
		jQuery(this)
			.find(ccos_Class).first()
			.addClass('ccos-active');
		jQuery(this)
			.find(ccos_Class)
			.on('mouseover', function() {
				jQuery(this).addClass('ccos-active').siblings().removeClass('ccos-active');
			});
	});
}

ScrollTrigger.matchMedia({
	"(max-width: 1200px)": function() {
		ScrollTrigger.getAll().forEach(t => t.kill());
	}
});


// on ready
$(document).ready(function() {
    ccos_staticbox_hover();
	ccos_title_animation();
});

// on resize
$(window).resize(function() {
	ccos_title_animation();
});

// on load
$(window).on('load', function(){
	ccos_multi_icon_box_hover_effect();
	ccos_card_verticel_pinning();
	ccos_sticky_special(); 
	ccos_img_animation();
	ccos_splite_slide();
	pbmt_vertical_snap();
    ccos_hover_img();
	
	setTimeout(cleaning, 500);
	function cleaning(){
		ScrollTrigger.refresh(); 
	}

	// Init cursor
    const cursor = new Cursor();
    $('[data-magnetic]').each(function() { new Magnetic(this); });
    gsap.delayedCall(1, () =>
        ScrollTrigger.getAll().forEach((t) => {
            t.refresh();
        })
    );
});
